import { RootState } from "../..";

export const selectList = (state: RootState) => state.languages.data.list;

export const selectIsListLoading = (state: RootState) =>
  state.languages.loading.list;
